import { render } from "./Location.vue?vue&type=template&id=0ea2b121"
import script from "./Location.vue?vue&type=script&lang=ts"
export * from "./Location.vue?vue&type=script&lang=ts"
script.render = render

export default script